import React from "react";

const Footer = () => {
    return (
        <section className="footer section container">
            <h3 className="footer__title">~Mir Anas~</h3>
        </section>
    );
};

export default Footer;
